module.exports = __webpack_public_path__ + "media/images/filter-7b2e3e92.svg";